/*
Written by Kevin Kasey and Austin Thibodeaux in June 2021
Documented by Austin Thibodeaux in April 2023

Component name:     QmAlert
Purpose:            Displays a red, yellow, or grey colored bubble depending on the 'type' prop.
                    none        => grey bubble
                    warning     => yellow bubble
                    critical    => red bubble
*/

import React, { HTMLAttributes } from 'react';

//---------------------------------------------------
//> THIS IS WHERE WE ADD THE 'OVAL' ALERT HIGHLIGHTS
export interface QmAlertProps extends HTMLAttributes<HTMLSpanElement> {
	type?: 'none' | 'warning' | 'critical';
	children?: React.ReactNode;
}

//---------------------------------------------------
const QmAlert: React.FC<QmAlertProps> = ({ type, children, ...restProps }) => {
	let className = 'destinfo';
	if (restProps) {
		className = className + ' ' + type;
	}
	return (
		<span {...restProps} className={className}>
			{' '}
			{children}
		</span>
	);
};

export default QmAlert;
